import { useEffect, useState } from 'react'
import noop from 'lodash/noop'

type Breakpoint = '>sm' | '>md' | '>lg' | '>xl'

// https://tailwindcss.com/docs/breakpoints
const queries: Record<Breakpoint, string> = {
  '>sm': '(min-width: 640px)',
  '>md': '(min-width: 768px)',
  '>lg': '(min-width: 1024px)',
  '>xl': '(min-width: 1280px)'
}

const useBreakpoint = (breakpoint: Breakpoint) => {
  const [doesMatch, onSetDoesMatch] = useState<boolean>(false)
  const query = queries[breakpoint]

  useEffect(() => {
    if (typeof window === 'undefined') {
      return noop
    }

    const onUpdateMatch = ({ matches }: { matches: boolean }) => {
      onSetDoesMatch(matches)
    }

    const matcher = window.matchMedia(query)

    const isModern = 'addEventListener' in matcher
    if (isModern) {
      matcher.addEventListener('change', onUpdateMatch)
    } else {
      // @ts-ignore
      matcher.addListener(onUpdateMatch)
    }

    onUpdateMatch(matcher)

    return () => {
      if (isModern) {
        matcher.removeEventListener('change', onUpdateMatch)
      } else {
        // @ts-ignore
        matcher.removeListener(onUpdateMatch)
      }
    }
  }, [query, onSetDoesMatch])

  return doesMatch
}

export default useBreakpoint
